import React from 'react';
import { Box } from '@mui/material';

const GlassCard = ({ children, sx, component = "div", href, ...props }) => {
  return (
    <Box
      component={component}
      href={href}
      sx={{
        background: 'rgba(18, 18, 20, 0.7)',
        backdropFilter: 'blur(12px)',
        border: '1px solid rgba(255, 255, 255, 0.05)',
        transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
        textDecoration: 'none',
        color: 'inherit',
        '&:hover': {
          borderColor: 'rgba(0, 240, 255, 0.3)',
          boxShadow: '0 0 30px rgba(0, 240, 255, 0.05)',
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export default GlassCard;